<script>
export default {}
</script>

<template>
	<v-app>
		<AppBar />
		<MobileMenuDrawer />
		<LoginDrawer />
		<CartDrawer />
		<v-main>
			<router-view />
		</v-main>
		<Footer />
	</v-app>
</template>
